import { atom } from 'recoil';

const fontSizeState = atom({
  key: 'fontSizeState',
  default: 32
});

export default fontSizeState;